import {
  Accordion,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  IconButton,
  useBreakpointValue,
  UseDisclosureReturn,
  VStack,
  Image,
} from "@chakra-ui/react";

import { ShiIcon } from "src/atoms";
import { Link } from "src/atoms/PrismicLink";
import ShiButton from "src/atoms/ShiButton";
import HeaderAccordionItem from "./HeaderAccordionItem";
import { onClickNewAccount } from "src/lib/event";
import useVisitorContext from "src/providers/VisitorContext/useVisitorContext";
import { useLocation } from "@reach/router";
import { ClickInfo } from "src/lib/event/types";

import { FC, Fragment } from "react";

import { HeaderSection } from "../types";

import { SiteNavbarData } from "../index";

type MobileDrawerProps = Pick<UseDisclosureReturn, "isOpen" | "onClose"> & {
  data: SiteNavbarData;
  headerSections: HeaderSection[];
  accountSegmentNavbarLogo?: any;
  version?: "v2" | "v3" | "v4" | "v5";
};

const MobileDrawer: FC<MobileDrawerProps> = ({
  isOpen,
  onClose,
  data,
  headerSections,
  accountSegmentNavbarLogo,
  version = "v2",
}) => {
  const size = useBreakpointValue({ base: "full", sm: "md" });
  const visitorContext = useVisitorContext();
  const location = useLocation();

  if (!data?.start_label || !data?.login_link) return null;
  const loginUrl = data.login_link?.url || ("https://app.shine.fr/" as string);

  return (
    <Drawer isOpen={isOpen} onClose={onClose} size={size} placement="top">
      <DrawerOverlay />
      <DrawerContent
        borderBottomRadius="lg"
        height="auto"
        maxHeight="100dvh"
        sx={{
          bottom: "initial !important",
        }}
      >
        <DrawerHeader
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          paddingY="space-8"
          paddingX="space-16"
        >
          <IconButton
            aria-label="Shine logo"
            variant="ghost"
            marginRight="space-24"
            marginLeft="2px"
            icon={
              version === "v5" && accountSegmentNavbarLogo?.url ? (
                <Image
                  src={accountSegmentNavbarLogo.url}
                  alt={accountSegmentNavbarLogo.alt || "Shine logo"}
                  width={{ base: "96px" }}
                  height="auto"
                />
              ) : (
                <ShiIcon
                  name="ShineLogo"
                  width={{ base: "96px" }}
                  height="auto"
                />
              )
            }
          />
          <DrawerCloseButton
            size="md"
            position="unset"
            sx={{
              svg: {
                width: "12px",
                height: "12px",
              },
            }}
          />
        </DrawerHeader>

        <DrawerBody
          display="flex"
          flexDirection="column"
          justifyContent="flex-start"
          paddingX="space-16"
          paddingY="space-32"
        >
          <Accordion
            textAlign="left"
            width="100%"
            allowToggle
            sx={{
              "> :first-of-type": {
                borderTop: "none",
              },
              "> .chakra-link": {
                display: "block",
                paddingY: "space-16",
              },
            }}
          >
            {headerSections?.map((section) => {
              if (!section || !section.primary) return;

              return (
                <Fragment key={section.id}>
                  <HeaderAccordionItem key={section.id} section={section!} />
                </Fragment>
              );
            })}
          </Accordion>
          <VStack
            mt="space-32"
            spacing="space-24"
          >
            <ShiButton
              onClick={(e) => {
                const clickInfo: ClickInfo = {
                  label: data.start_label,
                  platform: 'web-mobile',
                  block: 'site_navbar',
                  fromLocation: location
                };

                onClickNewAccount(e, visitorContext, clickInfo)
              }}
              variant="signup"
              size="md"
              hasArrow
            >
              {data.start_label}
            </ShiButton>

            <Link
              fontWeight="medium"
              variant="link-nav"
              href={loginUrl}
              whiteSpace="nowrap"
              color="grey-0"
            >
              {data.login_label}
            </Link>


          </VStack>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default MobileDrawer;
